<form class="m-h-12 m-v-8"
    [formGroup]="form" (ngSubmit)="onRechercher()">
    <h3>{{ 'sigt.integration.rechercheRde.form.droitContraintes.title' | translate }}</h3>

    <mat-form-field class="d-flex tour-interactif-step-0-step-0">
        <mat-label>{{ 'sigt.integration.rechercheRde.form.droitContraintes.statut' | translate }}</mat-label>
        <mat-select formControlName="statut"
            (selectionChange)="chargerListeEmetteur($event.value)">
            <mat-option *ngFor="let statut of statuts"
                [value]="statut.valeur">
                {{ statut.description }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="d-flex tour-interactif-step-0-step-1">
        <mat-label>{{ 'sigt.integration.rechercheRde.form.droitContraintes.numeroDroitContrainte' | translate
            }}</mat-label>
        <input matInput
            formControlName="numeroDroitContrainte"
            maxlength="250">
    </mat-form-field>

    <mat-form-field class="d-flex tour-interactif-step-0-step-2">
        <mat-label>{{ 'sigt.integration.rechercheRde.form.droitContraintes.date' | translate }}</mat-label>
        <mat-select formControlName="date">
            <mat-option value="DateModification">{{
                'sigt.integration.rechercheRde.form.droitContraintes.dateEnregistrementOuModification' | translate
                }}</mat-option>
            <mat-option value="DateEffective">{{ 'sigt.integration.rechercheRde.form.droitContraintes.datePriseEffet' |
                translate }}</mat-option>
            <mat-option value="DateEcheance">{{ 'sigt.integration.rechercheRde.form.droitContraintes.dateEcheance' |
                translate }}</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-grid-list class="tour-interactif-step-0-step-3"
        cols="2"
        rowHeight="2:1">
        <mat-grid-tile>
            <mat-form-field class="d-flex">
                <mat-label>{{ 'sigt.integration.rechercheRde.form.droitContraintes.du' | translate }}</mat-label>
                <input matInput
                    formControlName="dateDebut"
                    [matDatepicker]="pickerDateDebut">
                <mat-hint>{{ 'sigt.global.general.dateHint' | translate }}</mat-hint>
                <mat-datepicker-toggle matIconSuffix
                    [for]="pickerDateDebut"></mat-datepicker-toggle>
                <mat-datepicker #pickerDateDebut></mat-datepicker>
            </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile>
            <mat-form-field class="d-flex">
                <mat-label>{{ 'sigt.integration.rechercheRde.form.droitContraintes.au' | translate }}</mat-label>
                <input matInput
                    formControlName="dateFin"
                    [matDatepicker]="pickerDateFin">
                <mat-hint>{{ 'sigt.global.general.dateHint' | translate }}</mat-hint>
                <mat-datepicker-toggle matIconSuffix
                    [for]="pickerDateFin"></mat-datepicker-toggle>
                <mat-datepicker #pickerDateFin></mat-datepicker>
            </mat-form-field>
        </mat-grid-tile>
    </mat-grid-list>

    <mat-form-field class="d-flex tour-interactif-step-0-step-4">
        <mat-label>{{ 'sigt.integration.rechercheRde.form.droitContraintes.emetteur' | translate }}</mat-label>
        <mat-select formControlName="emetteur"
            multiple
            (selectionChange)="chargerNatureDroit($event.value)">
            <mat-option *ngFor="let dataEmetteur of dataSourceEmetteur"
                [value]="dataEmetteur.NoEmetteur">{{dataEmetteur.NomEmetteur}} ({{dataEmetteur.Acronyme}})</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="d-flex tour-interactif-step-0-step-5">
        <mat-label>{{ 'sigt.integration.rechercheRde.form.droitContraintes.natureDroit' | translate }}</mat-label>
        <mat-select formControlName="natureDroit"
            multiple>
            <mat-option *ngFor="let dataNatureDroit of dataSourceNatureDroit"
                [value]="dataNatureDroit.CodeNatureDroit">{{dataNatureDroit.NomNatureDroit}} ({{dataNatureDroit.CodeCategorieNatureDroit}})</mat-option>
        </mat-select>
    </mat-form-field>

    <div class="boutons-en-grille">
        <button mat-raised-button
            type="button"
            class="clear-search-button tour-interactif-rde-reinitialiser"
            (click)="initialiserChamps()">
            {{ 'sigt.global.boutons.reinitialiser' | translate }}
        </button>

        <button mat-raised-button
            type="submit"
            class="search-button tour-interactif-rde-rechercher"
            [disabled]="!form.valid|| buttonClicked"
            (click)="onRechercher()"
            color="primary">
            {{ 'sigt.global.boutons.rechercher' | translate }}
        </button>
    </div>

</form>